export const MUTATE_OPERATOR_TYPES = 'MUTATE_OPERATOR_TYPES'
export const MUTATE_LEGAL_ENTITY_FORMS = 'MUTATE_LEGAL_ENTITY_FORMS'
export const MUTATE_REGIONS = 'MUTATE_REGIONS'
export const MUTATE_PRIVILEGE_CATEGORIES = 'MUTATE_PRIVILEGE_CATEGORIES'
export const MUTATE_OPERATORS = 'MUTATE_OPERATORS'
export const FETCH_START = 'fetchStart'
export const MUTATE_REPORTS = 'mutateReports'
export const MUTATE_GUEST_VISITS = 'mutateGuestVisits'
export const FETCH_END = 'fetchEnd'
export const MUTATE_CURRENT_REPORT = 'MUTATE_CURRENT_REPORT'
export const MUTATE_CURRENT_OPERATOR = 'MUTATE_CURRENT_OPERATOR'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js